import React, { Component } from 'react';
import Scroll from 'react-scroll';
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom';
import _ from 'lodash'
import moment from 'moment'
import { getLatestPosts } from '../../api/butterCMS';
import { ContentBlock } from '../../components';
import { calculateReadTime } from '../../components/Blog/functions';
import { defaultAppTitle } from '../../config/functions';
import Error404 from '../Error404';

class Blog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            metaDescription: 'I\'ve writting some blog posts that hopefully will be useful. There\'ll be a bunch of topics covered; Javascript, CSS and other general development',
            featuredArticle: false,
            heroImageLoaded: false,
        
            apiError: false,
            pager: {
                current_page: this.props.match.params.page || 1,
                page_size: 5,
                num_pages: 0
            },
            articles: [],
        }

        this.scroll = Scroll.animateScroll;
        this.onImageLoaded = this.onImageLoaded.bind(this)
    }

    componentDidMount() {
        this.loadPosts()
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(this.props.match.params.page, prevProps.match.params.page )) {
            this.setPageNumber(this.props.match.params.page)
        }
    }

    setPageNumber(current_page) {
        this.setState({
            pager: {
                ...this.state.pager,
                current_page
            }
        }, () => {
            this.resetScroll()
            this.loadPosts()
        })
    }

    resetScroll() {
        this.scroll.scrollToTop({ duration: this.state.transitionSpeed });    
    }

    loadPosts() {
        const { current_page: page, page_size } = this.state.pager

        getLatestPosts({ page, page_size })
            .then(({ meta, data }) => {
                const articles = data

                this.setState({
                    // featuredArticle,
                    articles,
                    isLoading: false,
                    pager: {
                        ...this.state.pager,
                        next_page: meta.next_page,
                        num_pages: Math.ceil(meta.count / page_size)
                    }
                }, () => {
                    console.log( this.state )
                })
            })
            .catch(error => {
                console.error(error)
                this.setState({
                    apiError: true,
                    isLoading: false
                })
            })
    }

    onImageLoaded() {
        this.setState({
            heroImageLoaded: true
        })
    }

    render() {
        console.log( this.state )
        const { articles, isLoading, apiError } = this.state
        const { current_page, num_pages } = this.state.pager

        if (isLoading) {
            return (
                <div className="preloader preloader--force-display"></div>
            )
        }

        if (apiError) {
            return (
                <Error404 />
            )
        } 

        let pageLinks = []
        for (let i = 1; i <= num_pages; i++) {
            pageLinks.push(
                <li className="c-pager__item" key={i} onClick={this.setPageNumber.bind(this, i)}>
                    {i}
                </li>
            )
        }

        return (
            <div key="Blog">
                <Helmet>
                    <title>{`Blog // ${defaultAppTitle}`}</title>
                    <meta name="description" content={this.state.metaDescription} />
                    <meta name="og:description" content={this.state.metaDescription} />
                    <link rel="canonical" href={`https://davidwalker.info/blog${current_page > 1 ? `/p/${current_page}` : ''}`} />
                </Helmet>
                <ContentBlock className="content-block content-block--hero">
                    <h1 className="epsilon u-no-bm">Blog</h1>
                    <h2 className="beta u-no-bm">
                        Welcome to my blog! I've written, and will hopefully continue to write, some useful articles based on my past experiences.
                    </h2>
                </ContentBlock>

                <div>
                    {articles.map((article, k) => (
                        <ContentBlock className="content-block content-block--article c-article c-article--summary" key={k}>
                            <div className="c-article__img">
                                <Link className="u-unstyled" to={`/blog/${article.slug}`}>
                                    <img src={article.featured_image} alt={article.title} />
                                </Link>
                            </div>

                            <div className="c-article__summary">
                                <h3 className="beta">
                                    <Link className="u-unstyled" to={`/blog/${article.slug}`}>{article.title}</Link>
                                </h3>
                                <p className="u-margin--bottom-half">{article.summary}</p>

                                <div className="c-article__meta">
                                    <div className="epsilon u-margin--bottom">
                                        <p className="u-light-color u-no-bm epsilon">{`${moment(article.published).format('LL')} // ${calculateReadTime(article.body)} read`}</p>
                                    </div>

                                    <Link className="c-signpost__link c-signpost__link--inline u-more-link u-unstyled" to={`/blog/${article.slug}`}>
                                        Read article
                                    </Link>
                                </div>
                            </div>
                        </ContentBlock>
                    ))}

                    {num_pages > 1 ?                    
                        <ContentBlock className="content-block content-block--article u-text-center">
                            <ul className="c-pager">
                                <li className="c-pager__item c-pager__item--full">{`Viewing page ${current_page} of ${num_pages}`}</li>


                                <li className={`c-pager__item c-pager__item--link ${current_page == 1 ? 'c-pager__item--inactive' : ''}`}>
                                    {current_page > 1 ?
                                    <Link className="u-unstyled c-pager__item-link" to={`/blog/p/${parseInt(current_page) - 1}`}>Previous</Link>
                                    : 
                                    <span className="c-pager__item-link u-fake-link">Previous</span>
                                    }
                                </li>

                                <li className={`c-pager__item ${current_page >= num_pages ? 'c-pager__item--inactive' : ''}`}>
                                    {current_page < num_pages ?
                                    <Link className="u-unstyled c-pager__item-link" to={`/blog/p/${parseInt(current_page) + 1}`}>Next</Link>
                                    : 
                                    <span className="c-pager__item-link u-fake-link">Next</span>
                                    }
                                </li>
                            </ul>
                        </ContentBlock>
                    : ''}
                </div>

            </div>
        );
    }
}

export default Blog;



// WEBPACK FOOTER //
// ./src/pages/blog/index.js